module.exports = __webpack_public_path__ + "static/media/piper-sitting.4f3fa418.svg";